/* global game, CocoonJS */

Game.States.Load = {

	init: function() {

		this.input.maxPointers = 1;

		this.scale.pageAlignHorizontally = true;

	},

	preload: function() {

		// Add a progress bar
		var progressBar = game.add.sprite( game.world.centerX, game.world.centerY, 'progressBar' );
		progressBar.anchor.setTo( 0.5, 0.5 );
		game.load.setPreloadSprite( progressBar );

		this.load.path = '/assets/games/star-raid/';


		// Images

		game.load.image( 'world', 'images/world.png' );
		game.load.image( 'collision', 'images/collision.png' );
		game.load.image( 'intro', 'images/splash-screen.png' );
		game.load.image( 'font', 'images/font.png' );
		game.load.image( 'empty', 'images/null.png' );


		// Sprites

		game.load.spritesheet( 'confetti', 'images/confetti.png', 2, 2 );
		game.load.spritesheet( 'door-vertical-blue', 'images/door-vertical-blue.png', 8, 24 );
		game.load.spritesheet( 'door-vertical-green', 'images/door-vertical-green.png', 8, 24 );
		game.load.spritesheet( 'door-vertical-orange', 'images/door-vertical-orange.png', 8, 24 );
		game.load.spritesheet( 'door-vertical-red', 'images/door-vertical-red.png', 8, 24 );
		game.load.spritesheet( 'player', 'images/main-character.png', 14, 30 );
		game.load.spritesheet( 'hud', 'images/hud.png', game.width, 8 );
		game.load.spritesheet( 'coin', 'images/coins.png', 12, 12 );
		game.load.spritesheet( 'effect-dust-jump', 'images/effect-dust-jump.png', 18, 7 );
		game.load.spritesheet( 'key-blue', 'images/key-blue.png', 10, 10 );
		game.load.spritesheet( 'key-orange', 'images/key-orange.png', 10, 10 );
		game.load.spritesheet( 'key-red', 'images/key-red.png', 10, 10 );
		game.load.spritesheet( 'key-green', 'images/key-green.png', 10, 10 );
		game.load.spritesheet( 'terminal', 'images/terminal.png', 12, 16 );
		game.load.spritesheet( 'platform', 'images/platform.png', 32, 8 );


		// Audio

		// this.loadAudio( 'crash' );
		// this.loadAudio( 'weeeeee' );
		// this.loadAudio( 'countdown' );
		// this.loadAudio( 'jump-land' );
		// this.loadAudio( 'lose' );
		// this.loadAudio( 'ski-turn' );
		// this.loadAudio( 'splash' );
		// this.loadAudio( 'win' );
		// this.loadAudio( 'wind' );
		// this.loadAudio( 'theme' );
		// this.loadAudio( 'menu' );

		// Physics

		Phaser.Physics.Arcade.sortDirection = Phaser.Physics.Arcade.TOP_BOTTOM;

		// Load player data.
		//
		// TODO: Move this somewhere better.
		// Game.Utils.PlayerProperties.init();

	},

	create: function() {

		// Game.Utils.PalletSwap.swap( 'palette', 'player' );

		// Initialize stuff.
		// Game.Utils.Audio.init();
		Game.Utils.Controls.init();

		game.state.start( 'menu' );

	},


	loadAudio: function( file ) {

		var mp3 = 'audio/' + file + '.mp3';
		var ogg = 'audio/' + file + '.ogg';

		game.load.audio( file, [ mp3, ogg ] );

	}

};
